export enum JobCurationResult {
  PROPER = 'PROPER',
  NORMAL = 'NORMAL',
  NEED_CHECK = 'NEED_CHECK',
}

export const jobCurationResultTextMap: Record<JobCurationResultType, string> = {
  PROPER: '추천',
  NORMAL: '보통',
  NEED_CHECK: '고민 필요',
};

export const jobCurationResultColorMap: Record<JobCurationResultType, string> = {
  PROPER: 'green',
  NORMAL: 'gray',
  NEED_CHECK: 'red',
};

export type JobCurationResultType = keyof typeof JobCurationResult;
